import React, { useMemo } from 'react';
import ProjectSelectorButton from 'components/tasks/TasksViewer/ProjectSelectorButton';
import { Project } from 'services/projects/types';
import ProjectTag from './ProjectTag';
import { projectStatus } from './utils';

interface ProjectsLabelsInputProps {
  onChange: (projects: { id: string }[]) => void;
  projects?: Project[];
  value?: { id: string }[];
}

const ProjectsLabelsInput = ({
  onChange,
  projects,
  value,
}: ProjectsLabelsInputProps) => {
  const selected = useMemo(
    () => (Array.isArray(value) ? value : []).filter(project => project?.id),
    [value],
  );
  const selectedIds = useMemo(
    () => new Set(selected.map(project => project.id)),
    [selected],
  );
  const available = useMemo(
    () => (projects || [])
      .filter(project => !project.isArchived && projectStatus(project) !== 'Cancelled' && !selectedIds.has(project.id))
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())),
    [projects, selectedIds],
  );

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
      }}
    >
      {
        selected.map(project => (
          <ProjectTag
            key={project.id}
            onRemove={() => onChange(
              selected.filter(item => item.id !== project.id),
            )}
            projectId={project.id}
            truncate={false}
          />
        ))
      }
      <ProjectSelectorButton
        onSelect={project => onChange([...selected, { id: project.id }])}
        projects={available}
      />
    </div>
  );
};

export default ProjectsLabelsInput;
